export default __webpack_public_path__ + "static/media/redelegation-cap.5a4fcb01.svg";